/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecuteReportRequest
 */
export interface ExecuteReportRequest {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ExecuteReportRequest
     */
    parameters: { [key: string]: string; };
}

/**
 * Check if a given object implements the ExecuteReportRequest interface.
 */
export function instanceOfExecuteReportRequest(value: object): value is ExecuteReportRequest {
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    return true;
}

export function ExecuteReportRequestFromJSON(json: any): ExecuteReportRequest {
    return ExecuteReportRequestFromJSONTyped(json, false);
}

export function ExecuteReportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteReportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'parameters': json['parameters'],
    };
}

export function ExecuteReportRequestToJSON(json: any): ExecuteReportRequest {
    return ExecuteReportRequestToJSONTyped(json, false);
}

export function ExecuteReportRequestToJSONTyped(value?: ExecuteReportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parameters': value['parameters'],
    };
}

